import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardData } from '../../state/DashboardDataContext.jsx';
import { useUpgrade } from '../../contexts/UpgradeContext.jsx';
import { creationAccessState } from './CreationAccessNotice.jsx';

export default function GenerationFailureNotice({ code, message }) {
  const { t } = useTranslation();
  const dash = useDashboardData();
  const { openUpgrade } = useUpgrade();
  const billingRefusal = code === 'PLAN_LAPSED';
  return <div role="status" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 'var(--s-2)' }}>
    <span>{billingRefusal ? t('lapsed.generationBlocked') : message || t('batch.statusFailed')}</span>
    {billingRefusal && creationAccessState(dash) === 'lapsed' && <button
      type="button" className="btn btn-secondary btn-sm"
      onClick={event => { event.stopPropagation(); openUpgrade({ feature: 'default', variant: 'renew' }); }}
    >{t('lapsed.renew')}</button>}
  </div>;
}
